module.exports = __webpack_public_path__ + "img/logo_inrae_blanc.df45bd65.png";